var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItalicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6682 11.3243L4.68775 11.328C4.65423 11.6407 4.77619 11.9393 5.05363 12.2259C5.12998 12.3033 5.2147 12.3659 5.30873 12.4135H6.68103C6.98953 12.4135 7.23963 12.6642 7.23963 12.9735C7.23963 13.2827 6.98953 13.5335 6.68103 13.5335H0.681648C0.373141 13.5335 0.123047 13.2827 0.123047 12.9735C0.123047 12.6642 0.373141 12.4135 0.681648 12.4135H1.7523C2.1936 12.3481 2.50548 12.2436 2.68796 12.1017C2.83412 11.9879 2.95888 11.8031 3.06408 11.5445L5.31338 2.6312C5.34064 2.34932 5.2453 2.06936 5.05177 1.86306C4.93873 1.73918 4.79758 1.64442 4.64027 1.5868H3.33128C3.02277 1.5868 2.77268 1.33608 2.77268 1.0268C2.77268 0.717517 3.02277 0.466797 3.33128 0.466797H9.32973C9.63823 0.466797 9.88833 0.717517 9.88833 1.0268C9.88833 1.33608 9.63823 1.5868 9.32973 1.5868H8.21718C7.86712 1.63906 7.61203 1.73146 7.45096 1.86306C7.2508 2.0264 7.05715 2.2728 6.87095 2.6004L4.6682 11.3243Z",
    fill: "#31393C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicIcon);
export default ForwardRef;